import { Box } from '@dtx-company/shared-components/src/components/atoms/Box/index'
import { Divider } from '@dtx-company/shared-components/src/components/atoms/Divider/index'
import { Image } from '@dtx-company/shared-components/src/components/atoms/Image/index'
import { SimplePlanOptionData } from '../types'
import { Spacer } from '@dtx-company/shared-components/src/components/atoms/Spacer/index'
import { prismicCachedImage } from '@app/prismic/src/utils'
import CTAButton from './CTAButton'
import PrismicText from '@app/prismic/src/components/PrismicText/PrismicText'
import React from 'react'

const SimplePlanOption: React.FC<{ data?: SimplePlanOptionData }> = ({ data }) => {
  if (!data) return null

  return (
    <Box
      flexDirection="column"
      maxWidth="215px"
      mx={{ _: 'auto', md: '8px' }}
      mb={{ _: '52px', md: 'unset' }}
    >
      <Image
        src={prismicCachedImage(data.plan_name_logo?.url ?? '')}
        alt={data.plan_name_logo?.alt ?? 'logo'}
        height={{ _: '22px', lg: '32px' }}
      />
      <Spacer mb="16px" />
      <PrismicText richTextField={data.description} variant="body/medium" textAlign="center" />
      <Divider margin="8px 0px 16px 0px" />
      <PrismicText
        richTextField={data.price}
        variant="display/large"
        textAlign="center"
        color={data.color}
        lineHeight="40px"
        fontWeight="600"
      />
      <Spacer mb={{ _: '16px', md: '39px' }} />
      <Box flexDirection="column" alignItems={{ _: 'unset', md: 'center' }}>
        <CTAButton
          label={data.button_label}
          href={data.button_href?.url}
          variant={data.button_variant}
          backgroundColor={data.color}
          borderColor={data.color}
        />
      </Box>
    </Box>
  )
}

export default SimplePlanOption
